import React, { useRef, useEffect } from 'react'
import Formsy from 'formsy-react'
import { useFormsy } from 'commons/form'
import { DefaultSwitchFormsy } from '@fuse'
import {
  DialogTitle,
  DialogContent,
  Grid,
  Icon,
  useMediaQuery,
  Grow,
  Dialog,
  DialogActions,
} from '@material-ui/core'
import { TextInput } from 'app/components/FormsyHelperComponent'
import { useDialogStyle } from 'app/components/dialog/ResponsiveDialog'
import { FormattedMessage, useIntl } from 'react-intl'
import clsx from 'clsx'
import * as R from 'ramda'
import { useTheme } from '@material-ui/core/styles'
import GridAllItem from 'app/components/layout/GridAllItem'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import SecondaryButton from 'app/components/buttons/SecondaryButton'
import {
  MAX_TOPIC_DESCRIPTION_LENGTH,
  MAX_TOPIC_NAME_LENGTH,
} from './configs/constants'
import { useDispatch, useSelector } from 'react-redux'
import {
  topicFormInvalid,
  topicFormValid,
  topicSubmitInit,
  topicSubmitSucces,
} from './store/actions/topic-action'
import { makeStyles } from '@material-ui/core/styles'
import Assets from 'app/configs/assetConfigs'
import SwitchFormsy from '@fuse/components/formsy/SwitchFormsy'

export const Transition = React.forwardRef(function Transition(props, ref) {
  return <Grow ref={ref} {...props} />
})

const getDialogTitle = (isEditMode) => {
  return isEditMode
    ? 'notifications.topics.modal.edit.label'
    : 'notifications.topics.modal.create.label'
}

const getSubmitLabel = (isEditMode) => {
  return isEditMode
    ? 'notifications.topics.submit.button.update'
    : 'notifications.topics.submit.button.create'
}

const getButtonStyle = (isEditMode) => {
  return !isEditMode ? { padding: '8px 32px' } : null
}

export const useStyles = makeStyles((theme) => ({
  topicDialog: {
    '& .MuiDialogTitle-root': {
      paddingTop: '26px',
      paddingBottom: '0px',
      paddingLeft: '0',
      paddingRight: '0',
      color: '#404040',
      [theme.breakpoints.down('xs')]: {
        paddingLeft: '32px !important',
        paddingRight: '32px !important',
      },
    },
    '& .MuiDialogActions-root': {
      paddingLeft: '32px',
      paddingRight: '32px ',
      paddingTop: '10px',
      paddingBottom: '18px',
      [theme.breakpoints.down('xs')]: {
        paddingLeft: '32px',
        paddingRight: '32px',
      },
    },
    '& .MuiDialogContent-root': {
      paddingTop: '0',
      paddingBottom: '0',
      paddingLeft: '0',
      paddingRight: '0',
      overflowX: 'hidden',
      overflowY: 'overlay',
      [theme.breakpoints.down('xs')]: {
        paddingLeft: '16px !important',
        paddingRight: '16px !important',
      },
    },
  },
  swith: {
    '& .MuiFormControlLabel-root': {
      margin: 0,
    },
    '& .MuiSwitch-root': {
      marginLeft: '4px',
    },
  },
}))

const TopicCardDialog = (props) => {
  const { dialogState, isOpen = false, onSubmit, onClose } = props
  const classes = useDialogStyle()
  const theme = useTheme()
  const topicClasses = useStyles()
  const isDownWidth = useMediaQuery(theme.breakpoints.down('max-width:326px'))
  const formRef = useRef()
  const { isPristine, onChange } = useFormsy(formRef)

  const getStatusBoolean = R.compose(
    Boolean,
    R.defaultTo(1),
    R.prop('isActive'),
  )

  const dispatch = useDispatch()
  const { isTopicFormValid, topicNameErr, isSubmitting, isOpenTopicDialog } =
    useSelector((state) => state.topicReducer)

  const { formatMessage } = useIntl()

  const isEditMode = R.prop('isEditMode', dialogState)

  const getFormModel = () =>
    !R.isNil(formRef.current) ? formRef.current.getModel() : {}
  const formData = getFormModel()

  const resetFunc = () => {
    if (formRef.current) {
      return formRef.current.reset()
    }
  }

  useEffect(() => {
    resetFunc()
  }, [isOpenTopicDialog])

  const handleClose = () => {
    resetFunc()
    onClose()
  }

  const handleSubmit = async (values) => {
    dispatch(topicSubmitInit())

    if (dialogState && dialogState.isEditMode) {
      values = {
        ...values,
        id: dialogState.id,
        isActive: values.isActive ? 1 : 0,
      }
    }
    await onSubmit(values)
    if (topicNameErr) {
      resetFunc()
    }

    dispatch(topicSubmitSucces())
  }

  return (
    <Dialog
      fullScreen={false}
      classes={{
        paper: 'rounded-2xl',
      }}
      PaperProps={{
        className: topicClasses.topicDialog,
      }}
      open={isOpen}
      maxWidth="sm"
      TransitionComponent={Transition}
      onEscapeKeyDown={handleClose}
    >
      <Formsy
        onValidSubmit={handleSubmit}
        onValid={() => {
          dispatch(topicFormValid())
        }}
        onInvalid={() => {
          dispatch(topicFormInvalid())
        }}
        onChange={onChange}
        name={'topic-card'}
        ref={formRef}
      >
        <DialogTitle
          id="scroll-dialog-title"
          className={clsx(classes.dialogContent)}
        >
          <div className="flex justify-between flex-row items-center">
            <FormattedMessage id={getDialogTitle(isEditMode)} />
            <Icon
              className={clsx(classes.classClose, classes.iconSize)}
              onClick={handleClose}
              color="action"
            >
              close
            </Icon>
          </div>
        </DialogTitle>
        <DialogContent className="overflow-y-hidden pt-12">
          <GridAllItem
            spacing={2}
            className="pb-20"
            gridItemClassName={classes.dialogContent}
          >
            <Grid
              container
              alignItems="center"
              direction={isDownWidth ? 'column' : null}
            >
              <Grid item xs={12}>
                <Grid container>
                  {isEditMode && (
                    <div className="h-10">
                      <SwitchFormsy
                        name="isActive"
                        className={topicClasses.swith}
                        value={getStatusBoolean(dialogState)}
                        labelPlacement="start"
                        inputProps={{
                          'data-testid': 'isActive',
                        }}
                        label={formatMessage({
                          id: 'notifications.topics.modal.status.label',
                        })}
                      />
                    </div>
                  )}
                </Grid>
                {isEditMode && !formData.isActive && (
                  <div className="flex row nowrap justify-start items-stretch my-4 mt-5">
                    <div className="flex justify-center items-start mt-1 mr-3">
                      <img
                        className="w-32 align-middle self-start"
                        src={Assets.notiTypeInNotiCard.info}
                        alt="notiInactiveTopics"
                      />
                    </div>

                    <span className="text-grey-66 self-start text-xs font-bold">
                      <FormattedMessage id="notifications.topics.modal.info.inactive" />
                    </span>
                  </div>
                )}
              </Grid>
            </Grid>
            <TextInput
              errorMessage={topicNameErr}
              labelId="notifications.topics.modal.name.label"
              placeholderId="notifications.topics.modal.name.label"
              name="name"
              value={R.prop('name', dialogState)}
              getErrorMessage={() => {
                return topicNameErr ? (
                  <FormattedMessage id="notifications.topic.repeat.error" />
                ) : null
              }}
              required
              maxLength={MAX_TOPIC_NAME_LENGTH}
              fullWidth
              multiline
            />
            <TextInput
              labelId="notifications.topics.modal.description.label"
              placeholderId="notifications.topics.modal.description.label"
              name="description"
              value={R.prop('description', dialogState)}
              maxLength={MAX_TOPIC_DESCRIPTION_LENGTH}
              fullWidth
              multiline
              rows={4}
            />
          </GridAllItem>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            labelId="action.cancel"
            onClick={handleClose}
            style={getButtonStyle(isEditMode)}
          />
          <PrimaryButton
            isLoading={isSubmitting}
            disabled={
              !isTopicFormValid || isSubmitting || isPristine || topicNameErr
            }
            type="submit"
            labelId={getSubmitLabel(isEditMode)}
            style={getButtonStyle(isEditMode)}
          />
        </DialogActions>
      </Formsy>
    </Dialog>
  )
}

export default TopicCardDialog
